var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit-partner-app"}},[_c('h2',[_vm._v("Edit Partner")]),_vm._v(" "),_c('partner-app-form',{attrs:{"partnerId":_vm.partnerId,"partnerAppId":_vm.partnerAppId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4cf4e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PartnerAppEdit.vue
// module id = 1280
// module chunks = 1